const Countries = [
  { code: "AE", label: "United Arab Emirates" },
  { code: "SA", label: "Saudi Arabia" },
  { code: "OM", label: "Oman" },
  { code: "QA", label: "Qatar" },
  { code: "KW", label: "Kuwait" },
  { code: "BH", label: "Bahrain" },
  { code: "UK", label: "United Kingdom" },
  // { code: "GB", label: "Great Britain" },
  // { code: "ZA", label: "South Africa" },
];

export default Countries;
